interface PasswordCredentialData {
  id: string
  name?: string
  password: string
  iconURL?: string
}

interface PasswordCredentialConstructor {
  new (data: PasswordCredentialData): Credential
}

interface WindowWithPasswordCredential extends Window {
  PasswordCredential?: PasswordCredentialConstructor
}

export async function storePasswordCredential(email: string, password: string): Promise<void> {
  const PasswordCredential = (window as WindowWithPasswordCredential).PasswordCredential
  if (typeof window !== 'undefined' && 'PasswordCredential' in window && PasswordCredential) {
    try {
      const credential = new PasswordCredential({
        id: email,
        name: email,
        password,
      })
      await navigator.credentials.store(credential)
    } catch (err) {
      console.error(
        'Error storing credentials:',
        err instanceof Error ? err.message : 'Unknown error'
      )
    }
  }
}
